import React, { useState, useEffect } from 'react';
import { FaBirthdayCake, FaTimes } from 'react-icons/fa';

const AgeVerification: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const verified = localStorage.getItem('ageVerified');
    if (!verified) {
      setIsVisible(true);
    }
  }, []);

  const handleConfirm = () => {
    localStorage.setItem('ageVerified', 'true');
    setIsVisible(false);
  };

  const handleDecline = () => {
    window.location.href = 'https://www.google.com';
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm">
      <div className="glass-effect rounded-2xl p-8 max-w-md w-full mx-4 animate-fade-in">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <div className="bg-accent-primary/20 p-4 rounded-full">
              <FaBirthdayCake className="text-4xl text-accent-primary" />
            </div>
          </div>
          
          <h2 className="text-3xl font-bold mb-4 text-gradient">
            Age Verification Required
          </h2>
          
          <p className="text-dark-muted mb-8 text-lg">
            You must be 18 or older to access this website. By continuing, you confirm that you are of legal age to participate in online gambling in the UK.
          </p>
          
          <div className="flex gap-4">
            <button
              onClick={handleDecline}
              className="flex-1 px-6 py-3 bg-dark-card hover:bg-dark-border border border-dark-border rounded-lg transition-colors"
            >
              I'm Under 18
            </button>
            <button
              onClick={handleConfirm}
              className="flex-1 px-6 py-3 bg-gradient-to-r from-accent-primary to-accent-secondary hover:opacity-90 rounded-lg font-semibold transition-opacity"
            >
              I'm 18 or Older
            </button>
          </div>
          
          <p className="text-sm text-dark-muted mt-6">
            Please gamble responsibly. BeGambleAware.org
          </p>
        </div>
      </div>
    </div>
  );
};

export default AgeVerification;

